export class ManualRecipient {
  public Name: string = '';
  public Email: string = '';
}
